<!-- 任务4 -->
<template>
    <div>
      <div class="course_Task4">
        <el-row style="border: 1px solid #D3D3D3;margin: 0 20px 20px 20px;padding: 0 20px 20px 20px;min-height: calc(100vh - 280px);">
          <!-- <template v-if="examType == 2">
            <p style="background-color: rgb(239, 242, 247);margin: 0 -20px;color: #2789E2;padding: 20px;">
              任务得分：{{scoreInfo.score || 0}} 分
            </p>
          </template> -->
          <p class="fontB"><i class="el-icon-document-remove icon_"></i>任务名称：<span style="font-weight: 500;">{{taskInfo.taskTitle}}</span></p>
          <p class="fontB"><i class="el-icon-s-data icon_" style="color: #8a39c2;"></i>任务分值：
            <span style="font-weight: 500;">{{taskInfo.taskScore}} 分</span>
            <template v-if="examType == 2">
              <span style="color: red;margin-left: 100px;">任务得分：{{scoreInfo.score || 0}} 分</span>
            </template>
          </p>
          <p class="fontB"><i class="el-icon-document-copy icon_"></i>报告要求：</p>
          <el-row class="aljj">
            <previewIndex v-if="!$isEmpty(taskInfo.assessmentContent)" :modelValue="taskInfo.assessmentContent"></previewIndex>
          </el-row>
          <p class="fontB"><i class="el-icon-edit-outline icon_" style="color: #2eb68e;"></i>报告参考模板：</p>
          <el-row style="border:1px solid #D3D3D3;width: 50%;padding:20px;">
            <template v-for="(item ,index) in taskInfo.teacherOpenCourseHandsOnSimulationTasksFileList">
              <el-row class="mb10">
                <el-col :span="16">
                  <el-image class="course_Task4_img" :src="mb_d"></el-image>
                  <p class="m0 limit_line_one l_h40">{{item.fileName}}</p>
                  <!-- <p class="mb1">
                    120.kb
                    file：{{$matchType(item.fileName)}}
                  </p> -->
                </el-col>
                <el-col :span="8" class="t_r lineContent">
                  <el-button class="but_task" size="small" @click="downloadFile(item)" icon="el-icon-download" plain>下载</el-button>
                </el-col>
              </el-row>
            </template>
          </el-row>
          <p class="fontB"><i class="el-icon-upload2 icon_" style="color: #8a39c2;"></i>报告上传：</p>
          <el-row style="width: 50%;min-width: 500px;">
            <UploadFiles
              ref="taskPicture"
              :limit="1"
              :drag="true"
              accept=".PDF"
              v-if="showFile"
              :fileLists="reportFileList"
              @onSuccess="infoSuccess"
            />
            <el-row style="margin: 10px 0;" v-if="examType == 1 && taskReportInfo.reviewStatus != 1">
              <el-button type="primary" @click="addInfo" >提 交</el-button>
            </el-row>
          </el-row>
        </el-row>
      </div>
    </div>
</template>
<script>
import UploadFiles from "@/components/UploadFiles";	//上传
import previewIndex from "@/components/editorMd/previewIndex";	//富文本editorMd
export default {
  name: 'Task4',
  components: {
    UploadFiles,
    previewIndex
  },
  props: {
    courseType: { //课程类型 1教师开课 2系统授权
      type: Number,
      default: function(){
        return 1;
      }
    },
    examType: { //考试类型 1：考试 2：查看成绩
      type: Number,
      default: function(){
        return 1;
      }
    },
    taskId: { //任务ID
      type: String,
      default: function(){
        return "";
      }
    },
    handsOnId: { //实训ID
      type: String,
      default: function(){
        return "";
      }
    },
    courseId : { //课程ID
      type: String,
      default: function(){
        return "";
      }
    },
    scoreInfo:{ //分值信息
      type:Object,
      default: function(){
        return {};
      }
    }
  },
  data() {
    return {
      mb_d:require("../../../../images/course/mb_d@2x.png"),
      taskReportInfo:{reportScore:""}, //报告信息
      taskInfo:{}, //任务详情
      reportFileList:[],
      showFile:false,
      identityInfo:this.$ls.get(this.$getKeyInfo("identityInfo"))
    }
  },
  created() {
    this.getInfo();
    this.getHandsOnTaskReport();
  },
  mounted() {

  },
  methods: {
    getInfo(){ //获取详情
      let url = "/api/teacherOpenCourseHandsOnSimulationTasks/getInfo.do";
      if(this.courseType == 2){
        url = "/api/handsOnSimulationTasks/getInfo.do";
      }
      this.$get(url,{taskId:this.taskId,studentId:this.identityInfo.studentId}).then((ret) =>{
        if(ret.code == 0){
          this.taskInfo = ret.data;
          if(this.courseType == 2){
            this.taskInfo.teacherOpenCourseHandsOnSimulationTasksFileList = ret.data.tasksFileList;
          }
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    getHandsOnTaskReport(){
      this.$get("/api/studentHandsOnTaskReport/getCourseCentreReportTask.do",{courseType:this.courseType,handsOnTaskId:this.taskId,studentId:this.identityInfo.studentId,sourceType:this.examType}).then((ret) =>{
        if(ret.code == 0){
          if(!this.$isEmpty(ret.data)){
            this.taskReportInfo = ret.data;
            this.reportFileList = JSON.parse(ret.data.reportFile)
          }else{
            this.reportFileList = [];
          }
          this.showFile = true;
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    },
    downloadFile(item){ //下载文件
      this.$downLoadFile(item.fileUrl,item.fileName);
    },
    infoSuccess(file){ //上传成功回调
      this.reportFileList = [];
      for(let i in file){
        this.reportFileList.push(
        {
          fileName:file[i].name,
          fileUrl:file[i].url,
        });
      }
    },
    addInfo(){ //保存报告
      if(this.reportFileList.length <= 0){
        this.$message.warning("请选择需要上传的报告！")
        return;
      }
      let param = {
        courseType:this.courseType,
        teacherOpenCourseId:this.courseId,
        handsOnId:this.handsOnId,
        handsOnTaskId:this.taskId,
        studentId:this.identityInfo.studentId,
        studentHandsOnTaskReportId:this.taskReportInfo.studentHandsOnTaskReportId,
        reportFile:JSON.stringify(this.reportFileList) //只支持PDF
      }
      let url = "/api/studentHandsOnTaskReport/addCourseCentreReportTask.do";
      if(!this.$isEmpty(this.taskReportInfo)&&!this.$isEmpty(this.taskReportInfo.studentHandsOnTaskReportId)){
        url = "/api/studentHandsOnTaskReport/edit.do";
      }
      this.$postJSON(url,param).then((ret) =>{
        if(ret.code == 0){
          this.$message.success("保存成功！");
          this.getHandsOnTaskReport();
        }else{
          this.$message({message: ret.msg,type: 'error'});
        }
      });
    }
  }
};
</script>
<style  lang="less">
  .course_Task4{
    .icon_{
      color: #2789E2;margin-right: 10px;
    }
    .course_Task4_img{
      width: 40px;
      height: 40px;
      float: left;
      margin-right: 20px;
    }
    .but_task{
      color: #2789E2;border-color:#2789E2 ;margin-top: 5px;
    }
    .has-gutter{
      th{
        border-color:#E5E5E5;
        background-color: #EFF2F7;
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/lookCourse/components/PracticalTraining/Task5.vue